import {
    apiRequest,
    saudaraList,
    saudaraActive,
    saudaraInactive
} from "../../../../../../services/adapters/kepegawaian/saudaraService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", saudaraList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", saudaraInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", saudaraActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository